













































import Vue from "vue";
import { App } from "@/model/App";
import categories_list from "@/constants/categories_list";
import { Messages } from "@/constants/messages";
import InputForm from "@/components/InputForm.vue";
import DropdownSelector from "@/components/DropdownSelector.vue";
import LoadingDestore from "@/components/LoadingDestore.vue";
import { mapGetters } from "vuex";
import { PayloadEditApp, StateEditApp } from "@/store/app/types_app";
import { launchToast } from "@/utils/toast";
import URLInput from "@/components/URLInput.vue";
export default Vue.extend({
  name: "Update",
  components: { URLInput, InputForm, LoadingDestore, DropdownSelector },
  data(): {
    isLoading: boolean;
    updateApp: App;
    errorType: string;
    mess: any;
  } {
    return {
      isLoading: false,
      updateApp: {
        appName: "",
        appSummary: "",
        appUrl: "",
        appBanner: null,
        appCategories: [],
        appDescription: "",
        appIcon: null,
        appImages: [],
        appVideos: [],
      },
      errorType: "",
      mess: Messages,
    };
  },
  created() {
    let key: string;
    if (this.app) {
      for (key in this.app) {
        this.updateApp[key] = this.app[key];
      }
    }
  },
  computed: {
    ...mapGetters(["getStateEditApp"]),
    getCategories(): string[] {
      return categories_list.list;
    },
  },
  methods: {
    editApp(): void {
      const validateCategories = (
        this.$refs.dropdown_categories as any
      ).validateField();
      const validateURL = (this.$refs.input_url as any).validateField();
      const payloadEdit: PayloadEditApp = {
        sessionId: this.$store.getters.getSessionId,
        appUpdated: this.updateApp,
      };
      if (validateCategories && validateURL) {
        this.$store.dispatch("editApp", payloadEdit);
        console.log("Editing", this.updateApp, payloadEdit);
      }
    },
    receiveCategories(event: string[]): void {
      this.updateApp.appCategories = event;
    },
  },
  watch: {
    getStateEditApp: function () {
      if (this.getStateEditApp === StateEditApp.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        const toastMessage =
          this.getStateEditApp === StateEditApp.success
            ? "The app has been successfully updated"
            : "The app could not be updated";
        const toastType =
          this.getStateEditApp === StateEditApp.success
            ? "is-success"
            : "is-danger";
        launchToast(toastMessage, toastType);
        if (this.getStateEditApp === StateEditApp.success) {
          this.$emit("close");
          this.$emit("appUpdated", this.updateApp);
        }
      }
    },
  },

  props: {
    app: Object as () => App,
  },
});
